import React, {useMemo} from 'react';
import styled, {css} from 'styled-components';

import theme, {bp, color} from 'settings/theme';


type Props = {
  children?: React.ReactNode
};


// Product Header
const Component: React.FC<Props> = (props) => {

  return (
    <StyledComponent className="productPriceTable">
      {props.children}
    </StyledComponent>
  );

}


export default Component;




// Styles
const StyledComponent = styled.table`

  display: table;
  width: 100%;

  th{
    padding-top: 12px;   
    padding-bottom: 12px;
    font-size: 12px;
    font-weight: normal;
    text-align: center;
    border-bottom: solid 1px ${color.lines};
  }

  td{

    padding-top: 12px;   
    padding-bottom: 12px;
    font-size: 12px;
    font-weight: bold;
    text-align: center;

    small{
      font-weight: normal;
    }

  }

  tr:not(:last-child){

    td{
      border-bottom: solid 1px ${color.lines};
    }
      
  }


  @media (min-width: ${bp(4)}) {

    th{
      font-size: 14px;
      padding-top: 16px;   
      padding-bottom: 16px;
    }

    td{
      font-size: 14px;
      padding-top: 16px;   
      padding-bottom: 16px;
    }

  }

`;



